import { useEffect, useRef } from 'react';
import { registerDashboardRefreshExtra } from '../../utils/ui/dashboardPullRefresh';

/**
 * Registers a best-effort refetch that the role's pull-to-refresh (and silent
 * resume) runs alongside its core load. Latest-ref pattern; `enabled` false
 * unregisters. The fn may reject — the runner swallows it (warn only).
 *
 * @param {() => any} fn
 * @param {boolean} [enabled]
 * @param {{ key?: string, manualOnly?: boolean }} [opts] see registerDashboardRefreshExtra
 */
export default function useDashboardRefreshExtra(fn, enabled = true, opts = {}) {
  const { key, manualOnly } = opts;
  const fnRef = useRef(fn);
  fnRef.current = fn;
  useEffect(() => {
    if (!enabled) return undefined;
    return registerDashboardRefreshExtra(() => fnRef.current?.(), { key, manualOnly });
  }, [enabled, key, manualOnly]);
}
